export const ACCOUNTING_REFERENCE_SIGNATURE_RATES_SIGNATURE_FILTER = [
  'all',
  'signed',
  'unsigned',
] as const;

export const ACCOUNTING_REFERENCE_SIGNATURE_RATES_BREAKDOWN_SORT_BY = [
  'accref_name',
  'signature_rate',
  // 'signed_count', // We don't care about those sort options
  // 'total_count',
  // 'unsigned_count',
] as const;
